<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <div class="flex align-center justify-between">
        <div class="flex align-center justify-between">
          <div class="flex align-center margin-right-sm ">
            <span>试题名称：</span>
            <el-input v-model="keyword" placeholder="请输入试题名称" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm ">
            <span>类型：</span>
            <el-select v-model="type" placeholder="请选择类型" class="flex-sub" clearable>
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <div class="flex align-center">
          <router-link to="/home/questions-edit/0">
            <el-button type="primary">添加试题</el-button>
          </router-link>


          <el-upload
            class="avatar-uploader"
            ref="upload"
            :action="upFeil + '/Index/Importexcel/importQuestion'"
            :name="'file'"
            :data="fileData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
          >
            <el-button type="warning" class="margin-lr-sm">导入试题</el-button>
          </el-upload>


          <el-link :href="upFeil + '/static/题目导入模板.xls'" target="_blank" :underline="false">
            <el-button type="info">模版下载</el-button>
          </el-link>
        </div>

      </div>

      <div class="flex align-center justify-between margin-tb-sm">
        <div>
          共{{ total }}条数据
        </div>
        <div>
        </div>
      </div>

      <el-table
        :data="list"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="试题名称" prop="name">
          <template slot-scope="scope">
            <div class="ovHide" v-html="scope.row.question"></div>
          </template>
        </el-table-column>
        <el-table-column label="类型" prop="cate" width="220"></el-table-column>
        <el-table-column label="添加时间" prop="update_time" width="180"></el-table-column>
        <el-table-column label="试题状态" prop="name" width="150">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.is_show === 1"
              size="small"
              type="success"
              @click="stateItem(1,scope.row.id)"
            >已发布，点击下线
            </el-button>
            <el-button
              v-else
              size="small"
              type="primary"
              @click="stateItem(2,scope.row.id)"
            >已下线，点击发布
            </el-button>
          </template>
        </el-table-column>


        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <div class="table-operate" v-if="!scope.row.desc">

              <el-button
                size="small"
                type="primary"
                @click="editItem(scope.row.id)"
              >编辑
              </el-button>
              <el-button
                size="small"
                type="primary"
                @click="delItem(scope.row.id)"
              >删除
              </el-button>
            </div>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="list.length > 0"
        class="page-all"
        background
        @current-change="getList"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>


import {xiaoquServiceList} from "@/api/weilao";
import {delQuestion, questionCateList, questionList, setShowQuestion} from "@/api/study";
import {upFeil} from "@/config";

export default {
  name: "questions-list",
  data() {
    return {
      upFeil:upFeil,
      keyword: '',
      type: '',
      typeList: [],
      page: 1,
      limit: 10,
      total: 0,
      list: [],
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    fileData() {
      return {
        token: this.user.token,
      };
    },
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 试题管理", false);
    this.getTypeList()
    this.getList()
  },
  components: {},
  methods: {
    //  上传成功
    handleAvatarSuccess(res, file) {
      console.log(res)
      if (res.status === 200) {
        this.getList()
      } else {
        this.$message.error(res.data)
        this.$refs['upload'].clearFiles()
      }
    },
    //  获取分类列表
    async getTypeList() {
      const res = await questionCateList('', 1, 1000)
      this.typeList = res.data
    },
    //  搜索
    hanldSearch() {
      this.page = 1
      this.getList()
    },
    //  获取列表
    async getList() {
      const res = await questionList(this.keyword, this.type, this.page, this.limit)
      this.list = res.data
      this.total = res.total_number
    },
    //  上线/下线试题
    stateItem(state, id) {
      this.$confirm('您确定要' + (state === 2 ? '上线' : '下线') + '该试题吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureState(state, id);
      });
    },
    async sureState(state, id) {
      let _state = await setShowQuestion(state, id);
      this.getList();
      this.$message.success(_state.info);
    },


    //  添加修改试题
    editItem(id) {
      this.$router.push('/home/questions-edit/' + id)
    },
    async editType(id, val) {
      const state = await xiaoquServiceList(id, val)
      if (state.status === 200) this.$message.success('操作成功！')
    },
    //  删除试题
    delItem(id) {
      this.$confirm('您确定要删除该试题吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDel(id);
      });
    },
    async sureDel(id) {
      let _state = await delQuestion(id);
      if (this.list.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.info);
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
